import React, {useEffect, useState} from 'react';

const PerfInput = (props, ref) => {

  const {
    value
  } = props;

  const [tempValue, setTempValue] = useState(null);

  useEffect(() => {
    setTempValue(value);
  }, [value]);

  const componentProps = Object.assign({}, props);
  delete componentProps.Component;
  delete componentProps.getValueFromEvent;

  const getValueFromEvent = props.getValueFromEvent || (e => e.target ? e.target.value : e);

  return (
    <props.Component
      {...componentProps}
      ref={ref}
      value={tempValue}
      onChange={e => setTempValue(getValueFromEvent(e))}
      onBlur={() => props.onChange(tempValue)}
    />
  );
};

export default React.forwardRef(PerfInput);


// WEBPACK FOOTER //
// ./src/components/perf-input/index.jsx